import React from "react";
import { styled } from "styled-components";

import { KeyCommandIcon } from "../../components/icons/CustomIcons";
import HexLogo from "../../static/integration/hex-logo.inline.svg";

export const CliLogo = React.memo(function CliLogo() {
  return (
    <LogoContainer>
      <KeyCommandIcon />
      <HexLogo />
    </LogoContainer>
  );
});

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.fontColor.DEFAULT};
  margin-bottom: -24px;

  > :first-child svg {
    width: 24px;
    height: 24px;
  }

  > svg:last-child {
    width: 56px;
    height: 56px;
    rect {
      fill: #fff;
    }
    path {
      fill: #5f509d;
    }
  }
`;
